@if (
  marketType !== marketTypes.organization &&
  marketType !== marketTypes.group &&
  marketType !== marketTypes.shop &&
  countryCode !== hidenCountry
) {
  <img class="w-auto h-base" src="assets/images/{{ flag }}-new-flag.svg" />
}
